import React, { useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  MegaphoneIcon,
  ComputerDesktopIcon,
  BuildingOffice2Icon,
  BanknotesIcon,
  ArchiveBoxIcon,
} from "@heroicons/react/24/outline";
import MarketingPostsManagement from "./MarketingPostsManagement";
import SystemBannerManagement from "./SystemBannerManagement";
import CompanyBannerModeration from "./CompanyBannerModeration";
import PaidBannersManagement from "./PaidBannersManagement";
import StoriesManagement from "./StoriesManagement";

const TABS = [
  {
    key: "posts",
    label: "Маркетинг-посты",
    icon: MegaphoneIcon,
    hint: "Один пост — сториз в приложении, баннер на сайте и рассылка в чаты с выбором аудитории.",
    Component: MarketingPostsManagement,
  },
  {
    key: "public-banner",
    label: "Публичный баннер",
    icon: ComputerDesktopIcon,
    hint: "Какой баннер бизнес-пользователя показывается на главной сайта.",
    Component: SystemBannerManagement,
  },
  {
    key: "company-banners",
    label: "Баннеры компаний",
    icon: BuildingOffice2Icon,
    hint: "Проверка баннеров, которые загружают бизнес-аккаунты: одобрить или отклонить.",
    Component: CompanyBannerModeration,
  },
  {
    key: "paid-banners",
    label: "Платные баннеры",
    icon: BanknotesIcon,
    hint: "Оплаченные слоты на главной: модерация заявок и отключение активных.",
    Component: PaidBannersManagement,
  },
  {
    key: "stories-legacy",
    label: "Сториз (старые)",
    icon: ArchiveBoxIcon,
    legacy: true,
    hint: "Старая витрина сториз без баннера и рассылки. Для новых — «Маркетинг-посты».",
    Component: StoriesManagement,
  },
];

function MarketingHub() {
  const navigate = useNavigate();
  const location = useLocation();
  const tab = useMemo(() => {
    const key = new URLSearchParams(location.search).get("tab");
    return TABS.find((t) => t.key === key)?.key || TABS[0].key;
  }, [location.search]);

  const current = TABS.find((t) => t.key === tab) || TABS[0];
  const Active = current.Component;

  const changeTab = (key) => {
    const p = new URLSearchParams(location.search);
    p.set("tab", key);
    navigate({ pathname: location.pathname, search: `?${p.toString()}` }, { replace: true });
  };

  return (
    <div className="space-y-4 text-left">
      <div>
        <h2 className="text-2xl font-bold text-text-primary">Маркетинг и баннеры</h2>
        <p className="mt-0.5 text-sm text-text-secondary">{current.hint}</p>
      </div>

      <div role="tablist" className="flex gap-1 overflow-x-auto border-b border-border-primary">
        {TABS.map((t) => {
          const Icon = t.icon;
          const active = tab === t.key;
          return (
            <button
              key={t.key}
              type="button"
              role="tab"
              aria-selected={active}
              onClick={() => changeTab(t.key)}
              className={`-mb-px flex shrink-0 items-center gap-2 border-b-2 px-3 py-2.5 text-sm font-medium transition-colors ${
                active
                  ? "border-[#4F45E5] text-text-primary"
                  : `border-transparent hover:text-text-primary ${t.legacy ? "text-text-muted" : "text-text-secondary"}`
              }`}
            >
              <Icon className={`h-4 w-4 ${active ? "text-[#7C3AED]" : ""}`} />
              {t.label}
            </button>
          );
        })}
      </div>

      <div role="tabpanel">
        <Active key={tab} />
      </div>
    </div>
  );
}

export default MarketingHub;
